import {Component} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCard } from '@angular/material/card';
import {HeadlineTextComponent} from "../../components/headline-text/headline-text.component";
import {
  HeadlineWithIconAndInfoBoxComponent
} from "../../components/headline-with-icon-and-info-box/headline-with-icon-and-info-box.component";

@Component({
    selector: 'not-found-404',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: true,
  imports: [MatCard, TranslateModule, HeadlineTextComponent, HeadlineWithIconAndInfoBoxComponent]
})
export class PageNotFoundComponent {
}
